import { useEffect, useState } from "react";

// Returns `value` once it has stopped changing for `delayMs` - e.g. to avoid a
// request per keystroke.
export default function useDebouncedValue(value, delayMs = 300) {
  const [debounced, setDebounced] = useState(value);

  useEffect(
    function () {
      const timer = setTimeout(function () {
        setDebounced(value);
      }, delayMs);
      return function () {
        clearTimeout(timer);
      };
    },
    [value, delayMs],
  );

  return debounced;
}
